import { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';

import { DashboardScreen } from '../features/dashboard/DashboardScreen';
import { routePaths } from './routes';

const NotFoundScreen = lazy(async () => import('../features/notFound/NotFoundScreen'));

/**
 * The console's router (`CR-006`). The same shape as the user app's, in its own app — the two never import
 * from each other (`STD-002 §1`), and a lint rule fails the build if they try.
 */
export function AppRouter(): React.JSX.Element {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path={routePaths.dashboard} element={<DashboardScreen />} />
          <Route path={routePaths.notFound} element={<NotFoundScreen />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
